import React, { Component } from "react";
import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect,
    NavLink,
    HashRouter,
} from "react-router-dom";
import Header from "./../../Header";
import Pagination from "react-js-pagination";
import DatePicker from "react-datepicker";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import $ from "jquery";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import "./../../bootstrap/css/daterangepicker.css";
class Leave extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
        var localdata = has_local_data
            ? this.decrypt(localStorage.getItem("encdata"), 0)
            : "";
        this.state = {
            leaves: [],
            leave_detail: [],
            apiUrl: this.decryptconfigdata("apiUrl"),
            userAuthKey: has_local_data ? localdata.user_key : "",
            userId: has_local_data ? localdata.user_id : "",
            userEmail: has_local_data ? localdata.user_email : "",
            search: "",
            loading: 1,
            activePage: 1,
            startDate: new Date(),
            endDate: new Date(),
            fields: {},
            item_count: "",
            isLoadMore: 1,
            fromdate: "",
            todate: "",
        };
        this.searchChange = this.searchChange.bind(this);
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.onChange = this.onChange.bind(this);
        this.formdateChange = this.formdateChange.bind(this);
        this.todateChange = this.todateChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    formdateChange(event) {
        this.setState(
            {
                fromdate: event,
                from_date: moment(event).format("YYYY-MM-DD"),
                activePage: 1,
            },
            function () {
                this.leaveList();
            }
        );
    }

    todateChange(event) {
        this.setState(
            {
                todate: event,
                to_date: moment(event).format("YYYY-MM-DD"),
                activePage: 1,
            },
            function () {
                this.leaveList();
            }
        );
    }

    handleChangeStart(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-DD"),
        });
    }

    handleChangeEnd(date) {
        this.setState({
            endDate: date,
            end_date: moment(date).format("YYYY-MM-DD"),
        });
    }
    searchChange(event) {
        var obj = this;
        this.setState({ search: event.target.value, activePage: 1 });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.leaveList();
        }, 500);
    }
    onChange(propertyName, event) {
        const leave_detail = this.state.leave_detail;
        leave_detail[propertyName] = event.target.value;
        this.setState({ leave_detail: leave_detail });
        //console.log(this.state.leaves);
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div
                                    class="load_more"
                                    onClick={() => this.loadMore(this.state.activePage)}
                                >
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        );
                    } else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple">
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        );
                    }
                }
            }
        } else {
            return <div className="text-center">No Data Found</div>;
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 });
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(
            this.state.apiUrl +
            "/HrmanagementRest/LeaveList/userId/" +
            this.state.userId +
            "/userAuthKey/" +
            this.state.userAuthKey +
            "/page/" +
            pageNumber,
            {
                method: "POST",
                dataType: "json",
                body: JSON.stringify(this.state),
            }
        )
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                if (findresponse.leaves.length == 0) {
                    this.setState({
                        isLoadMore: 2,
                    });
                } else {
                    this.setState({
                        isLoadMore: 1,
                    });
                }
                this.setState({
                    leaves: this.state.leaves.concat(findresponse.leaves),
                });
            });
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $(".pages").addClass("disabled");
            });
            this.setState({ activePage: pageNumber, setPage: "no" });
            fetch(
                this.state.apiUrl +
                "/HrmanagementRest/LeaveList/page/" +
                pageNumber +
                "/userAuthKey/" +
                this.state.userAuthKey +
                "/userId/" +
                this.state.userId,
                {
                    method: "POST",
                    dataType: "json",
                    body: JSON.stringify(this.state),
                }
            )
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.decrypt(findresponse, 1);
                    $(document).ready(function () {
                        $(".pages").removeClass("disabled");
                        if (pageNumber == 1) {
                            $(".first_page").addClass("disabled");
                            $(".prev_page").addClass("disabled");
                        }
                        if (pageNumber == totalPages) {
                            $(".next_page").addClass("disabled");
                            $(".last_page").addClass("disabled");
                        }
                    });
                    this.setState({
                        leaves: findresponse.leaves,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: "yes",
                    });
                });
        }
    }

    leaveList(page = 1) {
        fetch(
            this.state.apiUrl +
            "/HrmanagementRest/LeaveList/page/" +
            page +
            "/userAuthKey/" +
            this.state.userAuthKey +
            "/userId/" +
            this.state.userId,
            {
                method: "POST",
                dataType: "json",
                body: JSON.stringify(this.state),
            }
        )
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leaves: findresponse.leaves,
                    item_count: findresponse.item_count,
                    loading: 0,
                    hr_permission: findresponse.hr_permission,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: "yes",
                });
                if (this.state.leaves.date !== undefined) {
                    if (this.state.leaves.date != "0000-00-00") {
                        this.setState({ startDate: new Date(this.state.leaves.date) });
                    }
                }
            });
    }

    delete_leave(id) {
        if (window.confirm("Are you sure! You want to delete the leave?")) {
            fetch(
                this.state.apiUrl +
                "/HrmanagementRest/LeaveDelete/id/" +
                id +
                "/userAuthKey/" +
                this.state.userAuthKey,
                {
                    method: "POST",
                    dataType: "json",
                    body: JSON.stringify(this.state),
                }
            )
                .then((Response) => Response.json())
                .then((findresponse) => {
                    window.location.href = "/leaves";
                });
        }
    }

    editLeaveDetails(id) {
        const fd = new FormData();
        fd.append("inputs", JSON.stringify(this.state));
        fetch(
            this.state.apiUrl +
            "/HrmanagementRest/editLeaveDetails/id/" +
            id +
            "/userAuthKey/" +
            this.state.userAuthKey,
            {
                method: "POST",
                dataType: "json",
                body: fd,
            }
        )
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.location.href = "/leaves";
            });
    }

    leave_details(id) {
        fetch(
            this.state.apiUrl +
            "/HrmanagementRest/LeaveDetails/id/" +
            id +
            "/userAuthKey/" +
            this.state.userAuthKey,
            {
                method: "POST",
                dataType: "json",
                body: JSON.stringify(this.state),
            }
        )
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                this.setState({
                    leave_detail: findresponse.leave_detail,
                });
                this.setState({ startDate: new Date(this.state.leave_detail.date) });
                this.setState({ endDate: new Date(this.state.leave_detail.to_date) });
            });
    }

    creditLeave(id) {
        return (
            <ul class="onclick-menu-content">
                <li>
                    <a>Credit Leave</a>
                </li>
            </ul>
        );
    }

    getUserRows() {
        if (this.state.loading) {
            return <div class="loader-new"></div>;
        } else {
            return (
                <div class="body-content">
                    <div class="employee-list table-wrap">
                        <table>
                            <thead>
                                <th class="intra_col_15">Employee Name</th>
                                <th class="intra_col_10">Employee Id</th>
                                <th class="intra_col_20">Leave Duration</th>
                                <th class="intra_col_10">Days</th>
                                <th class="intra_col_15">Reason</th>
                                <th class="intra_col_10">Type</th>
                                <th class="intra_col_10">Status</th>
                                {this.state.hr_permission == "yes" ? (
                                    <th class="intra_col_10">Action</th>
                                ) : (
                                    ""
                                )}
                            </thead>
                            <tbody>
                                {this.state.leaves.map((leaves, key) => (
                                    <tr>
                                        <td class="intra_col_15">
                                            <Link
                                                key={key}
                                                to={`/viewLeaveReward/${leaves.employee_id}`}
                                                name={"max"}
                                            >
                                                {leaves.name}
                                            </Link>
                                        </td>
                                        <td class="intra_col_10">
                                            <Link
                                                key={key}
                                                to={`/viewLeaveReward/${leaves.employee_id}`}
                                                name={"max"}
                                            >
                                                {leaves.muvi_employee_id}
                                            </Link>
                                        </td>
                                        <td class="intra_col_20">
                                            {leaves.date + " - " + leaves.to_date}
                                        </td>
                                        <td class="intra_col_10">
                                            {leaves.actual_leave_days > 1
                                                ? leaves.actual_leave_days + " Days"
                                                : leaves.actual_leave_days + " Day"}
                                        </td>
                                        <td class="intra_col_15">
                                            {leaves.note ? (
                                                <p>
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: leaves.note }}
                                                    />
                                                </p>
                                            ) : (
                                                "--"
                                            )}
                                        </td>
                                        <td class="intra_col_10">{leaves.leave_category}</td>
                                        <td class="intra_col_10">
                                            {leaves.status == "approved" ? (
                                                <span class="green">{leaves.status}</span>
                                            ) : (
                                                <span class="error">{leaves.status}</span>
                                            )}
                                        </td>
                                        <td class="intra_col_10">
                                            <div class="edit_delete">
                                                {/* <span class="edit" onClick={()=> this.leave_details(leaves.id)} data-toggle="modal" data-target="#editLeave"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></span>*/}
                                                {this.state.hr_permission == "yes" &&
                                                    leaves.status == "approved" ? (
                                                    <span
                                                        class="delete"
                                                        onClick={() => this.delete_leave(leaves.id)}
                                                    >
                                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                                    </span>
                                                ) : (
                                                    ""
                                                )}
                                                {/* <span class="delete" onClick={() => this.delete_leave(leaves.id)}><i class="fa fa-trash" aria-hidden="true"></i></span>*/}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {this.state.leaves.map((leaves, key) => (
                            <div class="customer_mob hidden-md">
                                <Link
                                    key={key}
                                    to={`/viewLeaveReward/${leaves.employee_id}`}
                                    name={"max"}
                                >
                                    <div class="custmer_list_mob">
                                        <div>{leaves.name ? leaves.name : "--"}</div>
                                        <div class="wrap">
                                            {leaves.date + " - " + leaves.to_date}
                                        </div>
                                        {/* <div tabindex="0" class="onclick-menu pull-right">
                     <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                     <ul class="onclick-menu-content">
                     <li onClick={()=> this.leave_details(leaves.id)} data-toggle="modal" data-target="#editLeave"><a>Edit</a></li>
                     <li onClick={() => this.delete_leave(leaves.id)}><a>Delete</a></li>
                     </ul>
                     </div> */}
                                    </div>
                                </Link>
                            </div>
                        ))}
                        {this.state.item_count > 0 ? (
                            <div
                                class="d-flex mu-pagination justify-content-between align-items-center"
                                aria-label="Page navigation example"
                            >
                                <div class="txt-dark">
                                    Showing {this.state.offset + 1}~
                                    {this.state.offset + this.state.off_count} of{" "}
                                    {this.state.item_count}
                                </div>
                                <div class="mu-pagination">
                                    <Pagination
                                        activePage={this.state.activePage}
                                        itemsCountPerPage={20}
                                        totalItemsCount={this.state.item_count}
                                        pageRangeDisplayed={5}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        onChange={
                                            this.state.setPage == "yes" ? this.handlePageChange : ""
                                        }
                                    />
                                </div>
                            </div>
                        ) : (
                            <div
                                className="text-center"
                                style={{
                                    color: "#333",
                                    fontSize: "16px",
                                    padding: "70px",
                                    fontWeight: "500",
                                }}
                            >
                                No Data Found
                            </div>
                        )}
                        {/* {this.loadMorecount()} */}
                    </div>
                </div>
            );
        }
    }

    leavesDateRangeSrch(start_date, end_date) {
        this.setState(
            {
                from_date: start_date.format("YYYY-MM-DD"),
                to_date: end_date.format("YYYY-MM-DD"),
                activePage: 1,
            },
            function () {
                this.leaveList();
            }
        );
    }

    componentDidMount() {
        document.title = "Intranet | Leave";
        if (!localStorage.getItem("userLogin")) {
            this.setState({ redirect: true });
        }
        this.leaveList();
        $(".searchTicket.dept").on("click", function () {
            $(this)
                .closest(".intranet_body")
                .find(".filter_dept")
                .slideToggle("slow");
        });
    }
    back() {
        window.location.href = "/leaves/";
    }
    render() {
        if (this.state.redirect) {
            return <Redirect to={"/login"} />;
        }

        if (this.state.hr_permission == "no") {
            return <Redirect to={"/home"} />;
        }
        const handleApply = (event, picker) => {
            picker.element.val(
                picker.startDate.format("DD/MM/YYYY") +
                " - " +
                picker.endDate.format("DD/MM/YYYY")
            );
            this.leavesDateRangeSrch(picker.startDate, picker.endDate);
        };
        const handleCancel = (event, picker) => {
            window.location.href = "/leaves";
        };
        const handleCallback = (start, end) => {
            this.leavesDateRangeSrch(start, end);
        };
        return (
            <div>
                <Header brecum_name="Leaves" brecum_page="Leaves" />
                <div class="right_col">
                    <div class="intranet_body">
                        <div class="title mob hidden-sm">
                            <span>Leaves</span>
                        </div>
                        <div class="top-row">
                            <div class="left-section leaves btn-muvi pull-left">
                                <a href="/leavesByEmployee" class="btn btn-sky mob">
                                    Leave Balances
                                </a>
                                <a href="/leaveRequests" class="btn btn-sky mob">
                                    Leave Requests
                                </a>
                                <a href="/leaveLops" class="btn btn-sky mob">
                                    Lops
                                </a>
                            </div>
                            <div class="right-section leaves pull-right">
                                <div class="row">
                                    <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                        <div class="filter ">
                                            <DateRangePicker
                                                initialSettings={{
                                                    showDropdowns: true,
                                                    autoUpdateInput: false,
                                                    linkedCalendars: false,
                                                    locale: {
                                                        cancelLabel: "Clear",
                                                    },
                                                }}
                                                onApply={handleApply}
                                                onCancel={handleCancel}
                                                onCallback={handleCallback}
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    defaultValue=""
                                                    placeholder="Leave From - Leave To"
                                                />
                                            </DateRangePicker>
                                        </div>
                                        <i class="fal fa-calendar-alt"></i>
                                    </div>
                                    <div class="col-md-6 col-xs-12">
                                        <div class="searchTicket emp_dept">
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="search"
                                                id="search"
                                                placeholder="Search By Name Or Employee Id"
                                                onChange={this.searchChange}
                                            />
                                            <button type="submit">
                                                <i class="fa fa-search"></i>
                                            </button>
                                        </div>
                                        <div class="searchTicket filter dept hidden-md">
                                            <i class="fa fa-sliders hidden-md filter"></i>
                                        </div>
                                    </div>
                                    {/*<div class="col-md-6 col-xs-12 padding_less mob-leave filter_dept">
                                        <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                            <div class="filter ">
                                                <DatePicker
                                                    selected={this.state.fromdate}
                                                    onChange={this.formdateChange}
                                                    placeholderText="Leave From"
                                                    dateFormat="DD/MM/YYYY"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    readOnly={true}
                                                />
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                        <div class="form-group col-sm-6 col-xs-6 icon-calender">
                                            <div class="filter right">
                                                <DatePicker
                                                    selected={this.state.todate}
                                                    onChange={this.todateChange}
                                                    placeholderText="Leave To"
                                                    readOnly={true}
                                                    dateFormat="DD/MM/YYYY"
                                                    peekNextMonth
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                />
                                            </div>
                                            <i class="fal fa-calendar-alt"></i>
                                        </div>
                                    </div>*/}
                                </div>
                            </div>
                            {/* <--modal start for edititng Leave-!> */}
                            <div class="modal fade" id="editLeave" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">
                                                &times;
                                            </button>
                                            <h4 style={{ color: "black" }} class="modal-title">
                                                Update Leaves
                                            </h4>
                                        </div>
                                        <div class="modal-body">
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="emp_name"
                                                placeholder="Employee Name"
                                                value={this.state.leave_detail.name}
                                                disabled
                                            />
                                            <br></br>
                                            <input
                                                type="text"
                                                class="form-control"
                                                name="emp_muvi_id"
                                                placeholder="Employee Id"
                                                value={this.state.leave_detail.muvi_employee_id}
                                                disabled
                                            />
                                            <br></br>
                                            Date Range
                                            <DatePicker
                                                selected={this.state.startDate}
                                                selectsStart
                                                startDate={this.state.startDate}
                                                endDate={this.state.endDate}
                                                onChange={this.handleChangeStart}
                                                onKeyDown={(e) => e.preventDefault()}
                                                dateFormat="dd/MM/yyyy"
                                            />
                                            <br></br>
                                            <DatePicker
                                                selected={this.state.endDate}
                                                selectsEnd
                                                startDate={this.state.startDate}
                                                endDate={this.state.endDate}
                                                onChange={this.handleChangeEnd}
                                                minDate={this.state.startDate}
                                                onKeyDown={(e) => e.preventDefault()}
                                                dateFormat="dd/MM/yyyy"
                                            />
                                            <br></br>
                                            Hours
                                            <select
                                                class="form-control"
                                                name="hours"
                                                value={this.state.leave_detail.hours}
                                                onChange={this.onChange.bind(this, "hours")}
                                            >
                                                <option value="0">0</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                            </select>
                                            <br></br>
                                            <textarea
                                                type="text"
                                                name="note"
                                                class="form-control"
                                                onChange={this.onChange.bind(this, "note")}
                                                value={this.state.leave_detail.note}
                                            ></textarea>
                                        </div>

                                        <div class="modal-footer">
                                            <button
                                                type="button"
                                                class="btn btn-blue"
                                                data-dismiss="modal"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="button"
                                                class="btn btn-sky"
                                                onClick={() =>
                                                    this.editLeaveDetails(this.state.leave_detail.id)
                                                }
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for editng Leave-!> */}
                        </div>
                        {this.getUserRows()}
                    </div>
                </div>
            </div>
        );
    }
}
export default Leave;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/leaves.js